
import { defineComponent, computed, onMounted, ref } from "vue";
import HomeHeader from "@/components/HomeHeader.vue";
import versionUpdate from "./modules/versionUpdate.vue";
import { useStore } from "vuex";
import { IGlobalState } from "@/store";
import * as Types from "@/store/action-types";
import VersionUpdate from "./modules/versionUpdate.vue";

export default defineComponent({
  components: {
    HomeHeader,
    VersionUpdate
  },
  setup() {
    onMounted(() => {
    })
    return {};
  },
});
